<mat-card class="card-version">
  <mat-card-title class="card-version-title">
    <p *ngIf="!isMainProduct || !isLargeVersionCard">{{ productRelease.Description ?? productRelease.ProductCode }}</p>
    <img *ngIf="isMainProduct && isLargeVersionCard" [src]="getProductImage(productRelease.ProductCode)" style="max-width: 200px;" [alt]="productRelease.ProductCode" >
  </mat-card-title>
  <mat-card-content >

    <div [style] ="isLargeVersionCard? 'display: flex;justify-content: space-between;' : 'display: flex;justify-content: space-between; border-radius: 0px 0px 20px 20px'"  [class]="['bg-' + family.toLowerCase().replace('.', '')  ] " >
      <div class="card-version-content-left">
        <p class="release"><span translate>COMMONS.RELEASE</span>: {{ productRelease.ReleaseNr }} </p>
        <p><span translate>PRODUCTS.RELEASE_DATE</span> {{ getDate(productRelease.PublicationDate) }}</p>
      </div>
      <div class="card-version-content-right">
        <div class="size" *ngIf="isDownloadableProduct() && downloadable && isLargeVersionCard">
          <button *ngIf="selectableLanguages.length == 0" [disabled]="buttonDisabled" (click)="download()" class="card-version-button" mat-fab color="primary">
            <mat-icon>download</mat-icon>
          </button>
          <button *ngIf="selectableLanguages.length > 0" [disabled]="buttonDisabled" [matMenuTriggerFor]="menu" class="card-version-button" mat-fab color="primary">
            <mat-icon>download</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngFor="let language of selectableLanguages" mat-menu-item (click)="download(language)">
              <mat-icon>download</mat-icon>
              <span translate>COMMONS.{{ getLanguageString(language) }}</span>
            </button>
          </mat-menu>
          <p class="size">{{ getFileName(productRelease.PublishedFileName).substring(getFileName(productRelease.PublishedFileName).length - 4) }} ({{ getReleaseFileSize(productRelease) }} MB)</p>
        </div>
        <div *ngIf="!isLargeVersionCard">
          <button [disabled]="buttonDisabled" (click)="openRelease()" class="card-version-button" mat-fab color="primary">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="isinProgress() && isLargeVersionCard" class="downloadStatusBarStyle">
      <p>{{ progressStatus.percentage }}%</p>
      <mat-progress-bar mode="determinate" [value]="progressStatus.percentage"></mat-progress-bar>
    </div>
    <div *ngIf="productRelease.InfoText && isLargeVersionCard" class="product-info-container"><p style="text-align: left;"><b><span translate>COMMONS.INSTALLATION_NOTES</span></b> {{productRelease.InfoText}}</p></div>

  </mat-card-content>


  <mat-card-actions *ngIf="isLargeVersionCard">

    <div style="margin-left: 0.8rem; margin-top: 0.8rem; text-align: center;">
      <a mat-list-item (click)="openFamilyReleases()">
        <p translate>COMMONS.VIEW_ALL_PRODUCT_FAMILY</p>
      </a>
    </div>
  </mat-card-actions>
</mat-card>

<!--<ul>
  <li *ngFor="let product of list">{{ product }}</li>
</ul>-->


<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>



